import { Link, useLocation } from "react-router";

import { StatusGlyph } from "../../components/StatusGlyph";
import { STATUSES } from "../../domain/status";
import { nl } from "../../i18n/nl";
import styles from "./companies.module.css";
import { countFor, filterLabel, useCompanyFilters } from "./filters";
import type { CompanyFilter } from "./filters";
import { useCompanyCounts } from "./queries";

/** Sidebar block (desktop): one filter at a time, with counters for the current search. */
export function StatusFilters() {
  const { pathname } = useLocation();
  const { filter, q, params } = useCompanyFilters();
  const counts = useCompanyCounts(q);
  const onCompanies = pathname === "/" || pathname.startsWith("/bedrijven/");

  function href(option: CompanyFilter) {
    const next = new URLSearchParams(onCompanies ? params : undefined);
    next.set("filter", option);
    return `/?${next.toString()}`;
  }

  return (
    <nav aria-label={nl.companies.filters} className={styles.sideFilters}>
      {(["alle", "voor-jou", ...STATUSES] as const).map((option) => {
        const active = onCompanies && filter === option;
        return (
          <Link
            key={option}
            to={href(option)}
            aria-current={active ? "true" : undefined}
            className={[styles.sideFilter, active && styles.sideFilterActive].filter(Boolean).join(" ")}
          >
            {option === "alle" || option === "voor-jou" ? (
              <span className={styles.sideFilterDot} aria-hidden="true" />
            ) : (
              <StatusGlyph status={option} size={14} />
            )}
            <span className={styles.sideFilterLabel}>{filterLabel(option)}</span>
            {counts.data && <span className={styles.sideFilterCount}>{countFor(option, counts.data)}</span>}
          </Link>
        );
      })}
    </nav>
  );
}
